/* saluvivo Desktop: Produktreihen mit der Maus ziehen; Vorteil-Icons als Vektor mit einmaliger Animation beim Scrollen.
   Bewegung nur Maus ab 990px und ohne «weniger Bewegung». Keine Inhalte werden verändert. */
(function(){
  if(window.svDesk)return;window.svDesk=true;
  var mq=window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)');
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var RAILS='.sv-rail,.bw__rail';

  /* ===== Produktreihen ziehen ===== */
  document.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse'||e.button!==0||!mq.matches)return;
    var rail=e.target.closest&&e.target.closest(RAILS);if(!rail||rail.scrollWidth<=rail.clientWidth+2)return;
    var x0=e.clientX,s0=rail.scrollLeft,moved=false,lx=x0,lt=performance.now(),v=0;
    function move(ev){
      var dx=ev.clientX-x0;
      if(!moved&&Math.abs(dx)>6){moved=true;rail.classList.add('is-drag');}
      if(!moved)return;
      rail.scrollLeft=s0-dx;
      var now=performance.now(),dt=Math.max(now-lt,1);v=(ev.clientX-lx)/dt;lx=ev.clientX;lt=now;
    }
    function up(){
      document.removeEventListener('pointermove',move);document.removeEventListener('pointerup',up);
      if(!moved)return;
      rail.classList.remove('is-drag');
      var fling=Math.max(-800,Math.min(800,-v*240));
      if(Math.abs(fling)>20)rail.scrollBy({left:fling,behavior:rm.matches?'auto':'smooth'});
      function stop(c){c.preventDefault();c.stopPropagation();}
      rail.addEventListener('click',stop,{capture:true,once:true});
      setTimeout(function(){rail.removeEventListener('click',stop,{capture:true});},50);
    }
    document.addEventListener('pointermove',move,{passive:true});document.addEventListener('pointerup',up);
  });
  document.addEventListener('dragstart',function(e){if(mq.matches&&e.target.closest&&e.target.closest(RAILS))e.preventDefault();});

  /* ===== Vorteil-Icons (Bereich «Vorteile»): Vektor-Nachzeichnung je Bilddatei =====
     Nur wenn alle Icons einer Reihe bekannt sind, wird die ganze Reihe ersetzt (einheitlicher Stil).
     Sonst bleiben die Bilder und bekommen eine ruhige, allgemeine Einblendung. */
  var F=' fill="currentColor" stroke="none"';
  var STEAM=function(xs){return xs.map(function(x,i){return '<path class="st st'+(i+1)+'" d="M'+x+' 15c-2.4-2.4 2.4-3.8 0-6.6"/>';}).join('');};
  var ICO={
    'molecule':'<g class="m-rot"><path d="M20 20L9 9M20 20L31 9M20 20L9 31M20 20L31 31"/><circle cx="9" cy="9" r="3.6"'+F+'/><circle cx="31" cy="9" r="3.6"'+F+'/><circle cx="9" cy="31" r="3.6"'+F+'/><circle cx="31" cy="31" r="3.6"'+F+'/><circle cx="20" cy="20" r="5"'+F+'/></g>',
    'hot-food':STEAM([13,20,27])+'<path d="M6 21H34A14 12 0 0 1 6 21Z"/><path d="M14 36H26"/>',
    'coffee':STEAM([15,21])+'<path d="M9 17H27V25A7 7 0 0 1 20 32H16A7 7 0 0 1 9 25Z"/><path d="M27 19H29.5A3.5 3.5 0 0 1 29.5 26H27"/><path d="M7 36H31"/>',
    'equalizer':'<path d="M6 11H34M6 20H34M6 29H34"/><circle class="k k1" cx="26" cy="11" r="4"'+F+'/><circle class="k k2" cx="14" cy="20" r="4"'+F+'/><circle class="k k3" cx="24" cy="29" r="4"'+F+'/>',
    'flash':'<path class="z" d="M23 4L9 23H19L17 36L31 17H21Z"/>',
    'calendar':'<rect x="6" y="9" width="28" height="26" rx="4"/><path d="M6 16H34M13 5V11M27 5V11"/><path class="ck" pathLength="1" d="M14 25.5L18.5 30L26 22"/>',
    'easy':'<circle cx="20" cy="20" r="14"/><path class="ck" pathLength="1" d="M13 20.5L18 25.5L27 15.5"/>',
    'puzzle':'<path d="M19 17V10H6V30H19V23A3.4 3.4 0 1 0 19 17Z"/><path class="pb" d="M21 17V10H34V30H21V23A3.4 3.4 0 1 0 21 17Z"/>',
    'powder':'<path d="M7 13H23A8 7 0 0 1 7 13Z"/><path d="M23 13L34 8"/><circle class="d d1" cx="11" cy="26" r="1.8"'+F+'/><circle class="d d2" cx="15.5" cy="31" r="1.8"'+F+'/><circle class="d d3" cx="12" cy="35.5" r="1.8"'+F+'/>',
    'chocolate':'<rect x="9" y="5" width="22" height="30" rx="3"/><path d="M20 15V35M9 15H31M9 25H31"/><rect class="pc" x="22.5" y="7" width="6.5" height="6" rx="1.2"'+F+'/>'
  };
  var KEY=/\/(molecule|hot-food|coffee|equalizer|flash|calendar|easy|puzzle|powder|chocolate)[^\/]*\.(webp|png|jpe?g|svg)/i;
  function key(src){var m=(src||'').split('?')[0].match(KEY);return m?m[1].toLowerCase():null;}
  function svg(k){return '<svg class="svq__icon sv-ico sv-ico--'+k+'" viewBox="0 0 40 40" width="40" height="40" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">'+ICO[k]+'</svg>';}
  var io=null;
  function play(g){g.classList.add('sv-ico-play');}
  function icons(scope){
    (scope||document).querySelectorAll('.svq__grid').forEach(function(g){
      if(g.getAttribute('data-sv-ico'))return;g.setAttribute('data-sv-ico','1');
      var imgs=[].slice.call(g.querySelectorAll('img.svq__icon'));if(!imgs.length)return;
      var ks=imgs.map(function(i){return key(i.getAttribute('src'));});
      var all=ks.every(function(k){return !!k;});
      imgs.forEach(function(img,i){
        var el=img;
        if(all){var w=document.createElement('span');w.innerHTML=svg(ks[i]);el=w.firstChild;img.parentNode.replaceChild(el,img);}
        else img.classList.add('sv-ico','sv-ico--gen');
        el.style.setProperty('--d',(i*0.35).toFixed(2)+'s');
      });
      if(!mq.matches||rm.matches||!('IntersectionObserver' in window))return;
      if(!io)io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){play(e.target);io.unobserve(e.target);}});},{threshold:0.6});
      io.observe(g);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){icons();});else icons();
  document.addEventListener('shopify:section:load',function(e){icons(e.target);});
})();
